import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { MenuItemTranslationFragment } from "@saleor/fragments/types/MenuItemTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsMenuItemPageProps
  extends TranslationsEntitiesPageProps {
  menuItem: MenuItemTranslationFragment;
}

export const fieldNames = {
  name: "name",
  url: "url",
  thumbnailUrl: "thumbnailUrl",
  mbThumbnailUrl: "mbThumbnailUrl"
};

const TranslationsMenuItemPage: React.FC<TranslationsMenuItemPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  menuItem,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation Menu Item "{menuItemName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            menuItemName: maybe(() => menuItem.name, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Menu Item Name"
            }),
            name: fieldNames.name,
            translation: maybe(() =>
              menuItem.translation ? menuItem.translation.name : null
            ),
            type: "short" as "short",
            value: maybe(() => menuItem.name)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Menu Item Url",
              description: "menuItem content"
            }),
            name: fieldNames.url,
            translation: maybe(() =>
              menuItem.translation ? menuItem.translation.url : null
            ),
            type: "short" as "short",
            value: maybe(() => menuItem.url)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "PC ThumbnailUrl",
              description: "menuItem content"
            }),
            name: fieldNames.thumbnailUrl,
            translation: maybe(() =>
              menuItem.translation ? menuItem.translation.thumbnailUrl : null
            ),
            type: "short" as "short",
            value: maybe(() => menuItem.thumbnailUrl)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "MB ThumbnailUrl",
              description: "menuItem content"
            }),
            name: fieldNames.mbThumbnailUrl,
            translation: maybe(() =>
              menuItem.translation ? menuItem.translation.mbThumbnailUrl : null
            ),
            type: "short" as "short",
            value: maybe(() => menuItem.mbThumbnailUrl)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsMenuItemPage.displayName = "TranslationsMenuItemPage";
export default TranslationsMenuItemPage;
